/*
 * Page addresses - Liste des adresses avec boutons pour ajouter, éditer, supprimer
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AddressData, addressesApi } from '../features/addresses';
import AddressesTable from 'features/addresses/components/AddressesTable';
import { AddButton } from '../common';

// Addresses page component
const Addresses: React.FC = () => {
	// State management
	const [addresses, setAddresses] = useState<AddressData[]>([]);
	const [loading, setLoading] = useState(true);
	// Navigation hook
	const navigate = useNavigate();

	// Fetch addresses on component mount
	useEffect(() => {
		// Get token from localStorage
		const token = localStorage.getItem('token');
		// If no token, exit
		if (!token) return;
		// Fetch addresses from API
		addressesApi
			.listPaginated(token, { limit: 999999 })
			.then((res) => setAddresses(res.data))
			.finally(() => setLoading(false));
	}, []);

	// Handlers for add, edit, and delete actions
	const handleAdd = () => navigate('/app/addresses/new');
	const handleEdit = (id: number) => navigate(`/app/addresses/${id}/edit`);
	const handleDelete = (id: number) => {
		const token = localStorage.getItem('token');
		if (!token) return;

		addressesApi
			.delete(id, token)
			.then(() => {
				setAddresses((prev) => prev.filter((address) => address.id !== id));
			})
			.catch((error) => console.error(error));
	};

	// Render the customers page
	return (
		<div className="min-h-screen bg-gray-100 p-6">
			<div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6">
				<div className="flex justify-between items-center mb-6">
					<h1 className="text-3xl font-bold">Gestion des adresses</h1>
					<AddButton
						label="Ajouter une adresse"
						onClick={handleAdd}
						size="lg"
					/>
				</div>

				{loading ? (
					<p>Chargement des adresses...</p>
				) : (
					<AddressesTable
						addresses={addresses}
						onEdit={handleEdit}
						onDelete={handleDelete}
					/>
					/*<p>Aucune donnée à afficher.</p>*/
				)}
			</div>
		</div>
	);
};
export default Addresses;
